import { Action, ThunkDispatch } from '@reduxjs/toolkit';

import { EntityType } from '@frontend/common';
import { useReactiveObject, useResolver } from '@frontend/repository';
import { SpotClient } from '@frontend/spot/api';
import { Spot } from '@frontend/spot/types';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useSpot:request': CustomEvent<string>;
    }
}

const REQUEST_SPOT_EVENT = 'useSpot:request';
const STORAGE_KEY = 'SPT_REQ';

export function spotRequest(spotId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_SPOT_EVENT, { detail: spotId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function SpotResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_SPOT_EVENT, EntityType.SPOT, (ids) => SpotClient.resolveSpots(ids), props.dispatch);
    return <></>;
}

interface UseSpotResolverProps {
    spotId?: string;
    fetchOnload?: boolean;
}
interface UseSpotResolverReturn {
    spot: Spot | null;
    initialising: boolean;
    isLoading: boolean;
}

/**
 * @description SpotResolver must be present in the app for this to work.
 */
export function useReactiveSpot({ spotId, fetchOnload = false }: UseSpotResolverProps): UseSpotResolverReturn {
    const { object: spot, initialising, isLoading } = useReactiveObject<Spot>({ id: spotId, entity_type: EntityType.SPOT, fetchOnload, resolveFunction: spotRequest });
    return { spot, initialising, isLoading };
}